import CustomAutocompleteWithListButtons from "@/components/Form/CustomAutocompleteWithListButtons";
import { useCountries } from "@/modules/Beeswax/beeswax.hook";
import { useBeeswaxList } from "@/modules/BeeswaxList/beeswaxList.hook";
import { listTypeList } from "@/modules/BeeswaxList/data";
import {
  SubModule,
  SubModuleCommonProps,
} from "@/modules/Presets/TargetingExpression/targetingExpression.interface";
import { formateDataForCustomSelect } from "@/utils/helpers";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box } from "@mui/material";
import { FieldValues } from "react-hook-form";
import SelectModuleWithType from "../SelectModuleWithType";
const moduleName = "geo";
export default function Geo<
  T extends FieldValues,
  U extends SubModule = "GEO"
>({
  control,
  errors,
  setValue,
  getValues,
  handleCreateCustomList,
  handleEditCustomList,
  parentName,
  isEdit,
  zipList,
  zipListLoading,
  countries,
  countriesLoading,
}: GeoProps<T, U>) {
  const {
    data: localZipList,
    isLoading: localZipListLoading,
    isFetching: localZipListFetching,
  } = useBeeswaxList(
    {
      queryParams: { type: "zip_code" },
      options: { enabled: !zipList && !zipListLoading },
    },
    "withType"
  );
  const {
    data: localCountries,
    isLoading: localCountriesLoading,
    isFetching: localCountriesFetching,
  } = useCountries({ enabled: !countriesLoading && !countries });

  zipList = isEdit && zipList ? zipList : localZipList;
  zipListLoading =
    isEdit && zipList
      ? zipListLoading
      : localZipListLoading && localZipListFetching;

  countries = isEdit && countries ? countries : localCountries;
  countriesLoading =
    isEdit && countries
      ? countriesLoading
      : localCountriesLoading && localCountriesFetching;
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        overflow: "auto",
        padding: 2,
      }}
    >
      <SelectModuleWithType<T>
        itemList={formateDataForCustomSelect(
          countries,
          "name",
          "countryCode3"
        )}
        control={control}
        errors={errors}
        name={`${parentName}.${moduleName}.country`}
        label="Country"
        setValue={setValue}
        getValues={getValues}
        loading={countriesLoading}
      />
      <Box sx={{ flexShrink: 0, mt: 1 }}>
        <CustomAutocompleteWithListButtons
          primaryName={`${parentName}.${moduleName}.zip_code_list.value.included`}
          secondaryName={`${parentName}.${moduleName}.zip_code_list.value.excluded`}
          itemList={formateDataForCustomSelect(zipList?.results, "name", "id")}
          handleEdit={handleEditCustomList}
          parentControl={control}
          label={"Zip List"}
          toolTip={
            "ZIP code or postal code of the user. Must be 5 or more characters. Zips must be split by commas."
          }
          extraLabelButtons={[
            {
              icon: AddRoundedIcon,
              handleOnClick: () =>
                handleCreateCustomList(
                  listTypeList.find(
                    (listItem) => listItem.componentKey === "zip"
                  )?.value
                ),
              toolTipText: "Add",
            },
          ]}
          loading={zipListLoading}
        />
      </Box>
    </Box>
  );
}
type GeoProps<T extends FieldValues, U> = U extends "GEO" ? Geo<T> : never;
interface Geo<T extends FieldValues> extends SubModuleCommonProps<T> {
  zipList: any;
  zipListLoading: boolean;
  countries: any;
  countriesLoading: boolean;
}
